module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adverts/adverts.component.css
// module id = ./src/app/components/adverts/adverts.component.css
// module chunks = main